/* eslint-disable react/jsx-no-bind */
import { Component, Host, h, Prop, EventEmitter, Event } from '@stencil/core';
import { DiscoveryAddition, SearchResultItem } from '@local/models';
import { Emitter } from 'mitt';
@Component({
  tag: 'cr-search-results',
  styleUrl: 'cr-search-results.css',
  shadow: true,
})
export class CrSearchResults {
  /**
   * A list of search results
   */
  @Prop() discoveries: Array<SearchResultItem> = [];

  /**
   * An application wide event bus
   */
  @Prop() applicationBus: Emitter<DiscoveryAddition> = null;

  @Event() discoveryClicked: EventEmitter<SearchResultItem>;

  render() {
    return (
      <Host>
        <div class="container">{this.discoveries.map(this.renderSearchResultRow)}</div>
      </Host>
    );
  }

  private handleSearchResultClicked = (discovery: SearchResultItem) => {
    this.discoveryClicked.emit(discovery);
  };

  private renderSearchResultRow = (discovery: SearchResultItem) => {
    return (
      <div
        class="row"
        onClick={() => {
          this.handleSearchResultClicked(discovery);
        }}
      >
        <div class="column">
          <div class="cell-container">
            <div class="identity" >
              <div title={discovery.scope}>{this.iconType(discovery)}</div>
              <div title={discovery.displayName} class="name">{discovery.displayName}</div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="cell-container">
            <div class="email" title={discovery.email}>
              {discovery.email}
            </div>
          </div>
        </div>
        <div class="column">
          <div class="cell-container">
            <div class="phone" title={discovery.phoneNumbers.length > 1 ? '' : `${discovery.phoneNumbers}`}>
              <cr-expandable-phone-number-list phoneNumbers={discovery.phoneNumbers} />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="cell-container">
            <div class="profession" title={discovery.state}>
              {discovery.state}
            </div>
          </div>
        </div>
        <div class="column">
          <div class="cell-container">
            <div class="actions">
            {
              ["lead", "professional"].includes(discovery.scope) && (
                <button
                  class="action-control"
                  title="Add"
                  onClick={(e) => {this.handleAddAction(discovery, e)}}
                >
                  <cr-icon-plus size="small" />
                </button>
              )
            }
              <button
                class="action-control"
                title="Open in new window"
                onClick={(e) => {this.handleOpenAction(discovery, e)}}
              >
                <cr-icon-arrow-up-right-from-square size="small" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  private iconType = (discovery: SearchResultItem) => {
    switch (discovery.scope) {
      case 'lead':
        return <cr-icon-professional-lead size="medium"></cr-icon-professional-lead>;
      case 'professional':
        return <cr-icon-professional size="medium"></cr-icon-professional>;
      case 'facility operator':
        return <cr-icon-facility-operator size="medium"></cr-icon-facility-operator>;
      case 'facility':
        return <cr-icon-facility size="medium"></cr-icon-facility>;
      default:
        return <cr-icon-professional size="medium"></cr-icon-professional>;
      // TODO add default icon
    }
  };


  private handleAddAction = (discovery, e) => {
    e.preventDefault()
    e.stopPropagation()
    if (this.applicationBus !== null) {
      this.applicationBus.emit('addDiscovery', discovery)
    }
  }

  private handleOpenAction = (discovery, e) => {
    e.preventDefault()
    e.stopPropagation()
    window.open(discovery.url, '_blank')
  }
}
